import React from "react";


const ABOUT = () => {
  return (
    <div class="bgabout">
    <div className=" pr-12 block w-full text-center bg-black abt-border  ">
    <h1 class ="h-8 mb-8 text-white italic font-bold text-4xl abt-h1">About the Project</h1>
      <p class="ml-20 text-white mb-5 bg-black text-2xl abt-p">
       Welcome to the official website of Ad-Axen. In this project we integrated NASA API's to make some inredible Services like APOD(astronomy picture of the day) , Earth(gets the image of any longitude and latitide of earth at a given time in history) ...etc. Which are listed below , click on <b>more info</b> to get the services working.
      </p>
      <br/>
      </div>
</div>
  )
}

export default ABOUT;
